import { motion } from "framer-motion";
import {
  Award, Sun, BadgeIndianRupee, ShieldCheck, Boxes, Truck, Package, Headset,
} from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { WHY_CHOOSE_US } from "@/data/site";

const ICONS = { Award, Sun, BadgeIndianRupee, ShieldCheck, Boxes, Truck, Package, Headset };

export default function WhyChooseUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="relative bg-[var(--muted)]/60 py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="max-w-2xl">
          <Reveal>
            <Overline>Why Choose Us</Overline>
            <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-tight text-[var(--ink)] sm:text-5xl">
              A wholesale partner you can rely on.
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {WHY_CHOOSE_US.map((w, i) => {
            const Icon = ICONS[w.icon];
            return (
              <motion.div
                key={w.title}
                data-testid={`why-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
                className="group rounded-2xl border border-[var(--border)] bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[var(--green)]/40 hover:shadow-xl hover:shadow-black/5"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[var(--gold)]/12 text-[var(--gold)] transition-transform duration-300 group-hover:scale-110">
                  <Icon size={22} />
                </span>
                <h3 className="mt-5 text-base font-semibold leading-snug text-[var(--ink)]">{w.title}</h3>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
